<template>
  <div class="region-fields">
    <h3>Pickup Points</h3>
    <div class="box">
      <form class="form" v-on:submit.prevent="createPoint">
        <fieldset>
          <div class="form-wrap">
            <div>
              <label for="point_name">Pickup Point Name</label>
              <input id="point_name" name="point_name" v-model="newPoint.pickup_point_name" type="text" required/>
          </div>
          <div class="form-submit-inline">
            <template v-if="this.$data.loading">
              <button type="submit" class="button" disabled><span>Adding pickup point...</span></button>
            </template>
            <template v-else>
              <button type="submit" class="button"><span>Add pickup point</span></button>
            </template>
          </div>
        </div>
      </fieldset>
    </form>
    <table class="table" cellspacing="0" cellpadding="0">
      <thead v-if="this.$data.points.length > 0">
        <tr>
          <th>Point Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="point of points" :key="point.id">
          <td>{{point.pickup_point_name}}</td>
          <td class="table-action"><a v-on:click="deletePoint(point.id)" class="icon icon--delete">Delete</a></td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'PickupPointsFields',
    components: mapGetters(['getLoadStatus']),
    data() {
      return {
        loading: false,
        points: [],
        newPoint: {},
      }
    },
    created() {
      this.getPoints()
    },
    methods: {
      getPoints() {
        this.$store.dispatch('setLoadStatus')
        fetch( this.$api + 'pickup/', {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch('setLoadStatus')
          this.$data.points = response.data
        })
      },
      createPoint() {
        this.$data.loading = true
        fetch(this.$api + 'pickup/', {
          method: 'POST',
          body: JSON.stringify(this.newPoint),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.point_name = ''
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.getPoints()
          this.newPoint = {}
          this.$data.loading = false
        })
      },
      deletePoint(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'pickup/' + data + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.success == true) {
            this.getPoints()
            this.$notify({
              type: 'success',
              title: response.message
            })
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            })
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            })
          }
          this.$store.dispatch('setLoadStatus')
        });
      },
    }
  }
</script>
